/**************************************************************************************************/
/*   File: /src/app/stores/states/dossier/state.ts                                                 */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Tuesday February 19th 2019                                                     */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed Apr 17 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { DossierContent } from '../../../shared/models/dossier.content';
import { DossierId } from '../../../shared/models/dossier.id';
import { Message } from '../../../shared/models/message';
import { FileModel } from '../../../shared/models/file.model';
import { DossierStatus } from '../../../shared/models/dossier.status';
import { Ambito } from '../../../shared/models';



/**
 * The dossier state
 */
export interface CreationState {
  /**
   * The dossier id
   */
  dossierId: DossierId;
  /**
   * The dossier content
   */
  dossierContent: DossierContent;
  /**
   * The messages
   */
  messages: Message[];
  /**
   * isLoading
   */
  isLoading: boolean;
  /**
   * Ambiti for creation
   */
  ambiti: Ambito[];

}

/**
 * The initial dossier state
 */
export const INITIAL_DOSSIER_CREATION_STATE: CreationState = {
  dossierId: undefined,
  dossierContent: undefined,
  messages: [],
  isLoading: false,
  ambiti: []
};

/**
 * The state name
 */
export const STATE_NAME = 'creation';